"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isAny_1 = require("../predicates/isAny");
exports.or = (...predicates) => {
    switch (predicates.length) {
        case 0: {
            return isAny_1.isAny;
        }
        case 1: {
            return predicates[0];
        }
        case 2: {
            const a = predicates[0];
            const b = predicates[1];
            return ((value) => a(value) || b(value));
        }
        case 3: {
            const a = predicates[0];
            const b = predicates[1];
            const c = predicates[2];
            return ((value) => a(value) || b(value) || c(value));
        }
        case 4: {
            const a = predicates[0];
            const b = predicates[1];
            const c = predicates[2];
            const d = predicates[3];
            return ((value) => a(value) || b(value) || c(value) || d(value));
        }
        case 5: {
            const a = predicates[0];
            const b = predicates[1];
            const c = predicates[2];
            const d = predicates[3];
            const e = predicates[4];
            return ((value) => a(value) || b(value) || c(value) || d(value) || e(value));
        }
        default: {
            return ((value) => {
                for (let i = 0; i < predicates.length; ++i) {
                    if (predicates[i](value)) {
                        return true;
                    }
                }
                return false;
            });
        }
    }
};
//# sourceMappingURL=or.js.map